/**
 * 管理后台 - 媒体报道管理 API
 */

import { httpGet, httpPost, httpPut, httpDelete, httpPatch } from '@/services/http';
import { transformMedia, transformMediaToBackend, BackendMedia, FrontendMedia } from '@/services/transform';

/** GET /api/admin/media - 列出所有媒体报道 */
export async function getAdminMedia(): Promise<FrontendMedia[]> {
  try {
    const data = await httpGet<BackendMedia[]>('/admin/media');
    return data.map(transformMedia);
  } catch (error) {
    console.error('获取管理媒体报道列表失败:', error);
    return [];
  }
}

/** POST /api/admin/media - 创建媒体报道 */
export async function createAdminMedia(data: Partial<FrontendMedia>): Promise<FrontendMedia | null> {
  try {
    const backendData = transformMediaToBackend(data);
    const result = await httpPost<BackendMedia>('/admin/media', backendData);
    return transformMedia(result);
  } catch (error) {
    console.error('创建媒体报道失败:', error);
    return null;
  }
}

/** PUT /api/admin/media/:id - 更新媒体报道 */
export async function updateAdminMedia(id: string, data: Partial<FrontendMedia>): Promise<FrontendMedia | null> {
  try {
    const backendData = transformMediaToBackend(data);
    const result = await httpPut<BackendMedia>(`/admin/media/${id}`, backendData);
    return transformMedia(result);
  } catch (error) {
    console.error('更新媒体报道失败:', error);
    return null;
  }
}

/** DELETE /api/admin/media/:id - 删除媒体报道 */
export async function deleteAdminMedia(id: string): Promise<boolean> {
  try {
    await httpDelete(`/admin/media/${id}`);
    return true;
  } catch (error) {
    console.error('删除媒体报道失败:', error);
    return false;
  }
}

/** PATCH /api/admin/media/:id/toggle-featured - 切换精选状态 */
export async function toggleMediaFeatured(id: string): Promise<boolean> {
  try {
    await httpPatch(`/admin/media/${id}/toggle-featured`);
    return true;
  } catch (error) {
    console.error('切换精选状态失败:', error);
    return false;
  }
}
